import CrudBase from '../../../CrudBase';
import axios from '../../../../axios-common';

class GoalSalesApi extends CrudBase {
	getGoalSales = (date, params) =>
		axios.get(`${this.endpoint}/get-by?date=${date}`, params);

	defaultMethods = {
		getGoalSales: this.getGoalSales,
	};
}

const acompanhamento = new GoalSalesApi('api/v1/goal-sales');

export default acompanhamento.defaultMethods;
